module.exports = __webpack_public_path__ + "img/20190528161851013.685d0c3b.png";